define(["require", "exports", "tslib", "mobx", "../utils/Environment"], function (require, exports, tslib_1, mobx_1, Environment_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Entity = exports.EntitySecurityAccessLevels = exports.PersistanceStates = void 0;
    var PersistanceStates;
    (function (PersistanceStates) {
        PersistanceStates[PersistanceStates["NEW_RECORD"] = 0] = "NEW_RECORD";
        PersistanceStates[PersistanceStates["EXISTING_MODIFIED"] = 1] = "EXISTING_MODIFIED";
        PersistanceStates[PersistanceStates["EXISTING_UNMODIFIED"] = 2] = "EXISTING_UNMODIFIED";
        PersistanceStates[PersistanceStates["MARKED_FOR_DELETION"] = 3] = "MARKED_FOR_DELETION";
    })(PersistanceStates || (exports.PersistanceStates = PersistanceStates = {}));
    var EntitySecurityAccessLevels;
    (function (EntitySecurityAccessLevels) {
        EntitySecurityAccessLevels[EntitySecurityAccessLevels["NO_ACCESS"] = 0] = "NO_ACCESS";
        EntitySecurityAccessLevels[EntitySecurityAccessLevels["READ_ONLY"] = 1] = "READ_ONLY";
        EntitySecurityAccessLevels[EntitySecurityAccessLevels["READ_WRITE"] = 2] = "READ_WRITE";
    })(EntitySecurityAccessLevels || (exports.EntitySecurityAccessLevels = EntitySecurityAccessLevels = {}));
    class Entity {
        init(entity = null, parent = null, observableFields) {
            (0, mobx_1.makeObservable)(this);
            this.parent = parent;
            if (entity) {
                this.onRead(entity, parent);
            }
            else {
                this.onCreate(parent);
            }
            this.onPostCreate(observableFields);
            this.onReady();
        }
        constructor() {
            Object.defineProperty(this, "PersistanceState", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PersistanceStateBeforeDelete", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SecurityAccessLevel", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsGeometryModified", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "ObjectId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ObjectIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Id", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "parent", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "changeObserver", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "changeEventListener", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: {}
            });
            Object.defineProperty(this, "watchChanges", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: true
            });
        }
        onPostCreate(observableFields) {
            let whitelist = {};
            observableFields.concat(["PersistanceState", "SecurityAccessLevel"]).forEach(x => {
                whitelist[x] = true;
            });
            this.changeObserver = (0, mobx_1.observe)(this, (change) => {
                const changedName = change.name.toString();
                if (whitelist[changedName]) {
                    const oldVal = change.type == "update" ? change.oldValue : null;
                    const newVal = change.object[change.name];
                    if (this.IsChangeEventObserverEnabled && oldVal !== newVal) {
                        if (!(0, Environment_1.isProduction)()) {
                            console.log(change.type, this.constructor.name + "." + changedName, "from", oldVal, "to", newVal);
                        }
                        if (change.name == "PersistanceState") {
                            if (newVal == PersistanceStates.MARKED_FOR_DELETION) {
                                this.PersistanceStateBeforeDelete = oldVal;
                            }
                        }
                        else {
                            if (change.name == "Shape") {
                                console.log("IsGeometryModified");
                                this.IsGeometryModified = true;
                            }
                            this.PersistanceState = this.PersistanceState == PersistanceStates.EXISTING_UNMODIFIED ? PersistanceStates.EXISTING_MODIFIED : this.PersistanceState;
                        }
                    }
                }
                if (this.IsChangeEventObserverEnabled) {
                    if (this.changeEventListener[changedName]) {
                        for (let delegate of this.changeEventListener[changedName]) {
                            try {
                                delegate(change);
                            }
                            catch (err) {
                                console.error(`${changedName} change event delegate failed`, err);
                            }
                        }
                    }
                }
            });
        }
        addChangeEventAction(field, eventHandler) {
            if (this.changeEventListener[field]) {
                this.changeEventListener[field].push(eventHandler.bind(this));
            }
            else {
                this.changeEventListener[field] = [eventHandler.bind(this)];
            }
        }
        hasChanges(recurseChildren = true) {
            return false;
        }
        walk(func) {
            throw new Error("Subclass must implement");
        }
        reset(recurseChildren = false) {
            if (recurseChildren) {
                this.walk((entity) => {
                    Object.keys(entity).forEach((k, index) => {
                        if (entity.hasOwnProperty(k + "Error")) {
                            entity[k + "Error"] = null;
                        }
                    });
                });
            }
            else {
                Object.keys(this).forEach((k, index) => {
                    if (this.hasOwnProperty(k + "Error")) {
                        this[k + "Error"] = null;
                    }
                });
            }
        }
        markForDeletion() {
            this.PersistanceState = PersistanceStates.MARKED_FOR_DELETION;
        }
        undoDeletion() {
            this.PersistanceState = this.PersistanceStateBeforeDelete;
        }
        get IsMarkedForDeletion() {
            return this.PersistanceState == PersistanceStates.MARKED_FOR_DELETION;
        }
        dispose() {
            this.changeObserver && this.changeObserver();
        }
        disableChangeObserver() {
            this.watchChanges = false;
        }
        enableChangeObserver() {
            this.watchChanges = true;
        }
        get IsChangeEventObserverEnabled() {
            if (this.parent) {
                return this.watchChanges && this.parent.IsChangeEventObserverEnabled;
            }
            return this.watchChanges;
        }
        mergeObject(a, b, C) {
            if (!a && !b) {
                a = undefined;
            }
            else if (!a) {
                a = new C(b, this);
            }
            else if (!b) {
                a = undefined;
            }
            else {
                a.merge(b);
            }
            return a;
        }
        mergeArray(a = [], b = [], C) {
            let added = b.filter(bx => !a.find(ax => ax.Id === bx.Id));
            let removed = a.filter(ax => !b.find(bx => bx.Id === ax.Id));
            let updated = b.filter(bx => a.find(ax => ax.Id === bx.Id));
            added.forEach(bx => {
                a.push(new C(bx, this));
            });
            removed.forEach(ax => {
                if (!(0, Environment_1.isProduction)()) {
                    console.log(`Remove item at ${a.findIndex(x => x.Id === ax.Id)}`);
                }
                a.splice(a.findIndex(x => x.Id === ax.Id), 1);
            });
            updated.forEach(bx => {
                a.find(ax => ax.Id === bx.Id).merge(bx);
            });
            return a;
        }
        validateReqNumber(validationState, field, alias, opts = {}, addToState = true) {
            const applyDefaults = (props) => {
                const MAX_NUMBER = 9999999999;
                let min;
                let max;
                let allowNegative = props.allowNegative != undefined ? !!props.allowNegative : true;
                let isPc = !!props.isPc;
                let precision = props.precision ? props.precision : (isPc ? 4 : 0);
                if (isPc) {
                    min = props.min >= 0 && props.min < 1 ? props.min : 0;
                    max = props.max <= 1 && props.max > 0 ? props.max : 1;
                }
                else {
                    min = props.min || (allowNegative ? MAX_NUMBER * -1 : 0);
                    max = props.max;
                    if (max === undefined) {
                        const modelLength = this.constructor[field + "Length"];
                        if (modelLength) {
                            max = parseInt(new Array(modelLength).join("9"));
                        }
                        else {
                            max = MAX_NUMBER;
                        }
                    }
                }
                return Object.assign(Object.assign({}, props), { isPc,
                    allowNegative,
                    precision,
                    min,
                    max });
            };
            const { min, max, precision, allowNegative, isPc } = applyDefaults(opts);
            const isNumberRegexPattern = isPc
                ? `^\\d{1,3}${precision ? `\\.?\\d{0,${precision}}` : ""}$`
                : `^${!!allowNegative ? "-?" : ""}\\d{0,${max.toString().length}}${precision ? `\\.?\\d{0,${precision}}` : ""}$`;
            const isNumberRegex = new RegExp(isNumberRegexPattern);
            const value = this[field];
            if (isNaN(value) || !isNumberRegex.test(value)) {
                if (this.constructor[field + "Domain"] === true) {
                    this[field + "Error"] = `${alias} is required`;
                }
                else {
                    if (precision > 0) {
                        this[field + "Error"] = `${alias} must be a number (max ${precision} decimal places)`;
                    }
                    else {
                        this[field + "Error"] = `${alias} must be a number`;
                    }
                }
            }
            else if (value < min || value > max) {
                this[field + "Error"] = `${alias} must be between ${min} & ${max}`;
            }
            else {
                this[field + "Error"] = null;
            }
            if (!(0, Environment_1.isProduction)() && this[field + "Error"]) {
                console.log(field, { min, max, precision, allowNegative, isPc, value, pass: isNumberRegex.test(value), isNumberRegex: isNumberRegex.source });
            }
            if (addToState && this[field + "Error"]) {
                let m = {
                    Id: this.Id,
                    Field: field,
                    Msg: this[field + "Error"]
                };
                validationState.addError(m);
            }
        }
        validateReqString(validationState, field, alias, addToState = true) {
            let value = this[field];
            this[field + "Error"] = (!value || value.trim().length == 0) ? `${alias} is required` : null;
            if (addToState && this[field + "Error"]) {
                let m = {
                    Id: this.Id,
                    Field: field,
                    Msg: this[field + "Error"]
                };
                validationState.addError(m);
            }
        }
        validateReqDate(validationState, field, alias, addToState = true) {
            let value = this[field];
            this[field + "Error"] = !value ? `${alias} is required` : null;
            if (addToState && this[field + "Error"]) {
                let m = {
                    Id: this.Id,
                    Field: field,
                    Msg: this[field + "Error"]
                };
                validationState.addError(m);
            }
        }
    }
    exports.Entity = Entity;
    Object.defineProperty(Entity, "ObjectIdRequired", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(Entity, "IdRequired", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], Entity.prototype, "PersistanceState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Entity.prototype, "PersistanceStateBeforeDelete", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Entity.prototype, "SecurityAccessLevel", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Entity.prototype, "IsGeometryModified", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Entity.prototype, "ObjectId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Entity.prototype, "ObjectIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Entity.prototype, "Id", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], Entity.prototype, "IdError", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], Entity.prototype, "onPostCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Entity.prototype, "markForDeletion", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Entity.prototype, "undoDeletion", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Entity.prototype, "mergeObject", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Entity.prototype, "mergeArray", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Entity.prototype, "validateReqNumber", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Entity.prototype, "validateReqString", null);
    tslib_1.__decorate([
        mobx_1.action
    ], Entity.prototype, "validateReqDate", null);
});
